/**
 * ProviderType — Enum loại provider đăng nhập + auth provider type
 * CreatedBy: dbhuan (14/06/2026)
 * UpdatedBy: dbhuan (16/06/2026) — them AUTH_MISA_ID, AUTH_JETPAY_ID
 */
export const ProviderType = {
  /** AMIS Platform */
  AMIS: "MC_AMIS",
  /** MISA ID */
  MISA_ID: "MISA_ID",
  /** Auth provider type — MISA ID (dùng cho getAuthConfig / OIDC) */
  AUTH_MISA_ID: "MISAID_V2",
  /** Auth provider type — JetPay ID (dùng cho getAuthConfig / OIDC) */
  AUTH_JETPAY_ID: "MISAID",
};

/** @typedef {"MC_AMIS"|"MISA_ID"} ProviderTypeValue */
